import { memo, ReactElement } from 'react'
import { UseQueryResult } from 'react-query'
import ErrorIndicator from './components/ErrorIndicator'
import LoadingIndicator from './components/LoadingIndicator'

type Props = {
  queries: UseQueryResult | UseQueryResult[]
  children: () => ReactElement
}

function ApiSuspense({ queries, children }: Props): ReactElement {
  if (Array.isArray(queries)) {
    if (queries.filter(status => status.isLoading).length > 0) {
      return <LoadingIndicator />
    }
    const failedRequests = queries.filter(status => status.isError)
    if (failedRequests.length > 0) {
      return <ErrorIndicator />
    }
  } else {
    if (queries.isLoading) {
      return <LoadingIndicator />
    }
    if (queries.isError) {
      return <ErrorIndicator />
    }
  }

  return children()
}

export default memo(ApiSuspense)
